const yesOrNotEnum = {
  yes: 1,
  no: 2,
};

export default yesOrNotEnum;
